export { default as SchoolGradeOlogy } from './GradeOlogyPortlet/SchoolGradeOlogy';
export { default as SchoolOlogyBooks } from './OlogyBooks/SchoolOlogyBooks';
